import { SubscriptionPlansList } from './SubscriptionPlansList';
import { SubscriptionPlansCreate } from './SubscriptionPlansCreate';
import { SubscriptionPlansEdit } from './SubscriptionPlansEdit';

export default {
    list: SubscriptionPlansList,
    create: SubscriptionPlansCreate,
    edit: SubscriptionPlansEdit,
};